// Better name for this file which represents 6pm/zappos??
import feedbackSagas from 'store/ducks/feedback/sagas';
import { createRootSaga } from 'helpers/SagaUtils';
import giftOptionsSagas from 'store/ducks/giftoptions/sagas';
import checkoutSagas from 'store/ducks/checkout/sagas';
import laSagas from 'store/ducks/loginAssistant/sagas';
import killswitchSagas from 'store/ducks/killswitch/sagas';
import productDetailSagas from 'store/ducks/productDetail/sagas';
import rewardsSagas from 'store/ducks/rewards/sagas';
import sessionSagas from 'store/ducks/session/sagas';
import eventSagas from 'store/ducks/events/sagas';
import searchSagas from 'store/ducks/search/sagas';
import weblabSagas from 'store/ducks/weblab/sagas';
import makeRoutes from 'routes';

const sagas = [
  ...eventSagas,
  ...checkoutSagas,
  ...feedbackSagas,
  ...killswitchSagas,
  ...laSagas,
  ...giftOptionsSagas,
  ...rewardsSagas,
  ...sessionSagas,
  ...searchSagas,
  ...weblabSagas,
  productDetailSagas
];

const storeOptions = {
  reducers: {},
  rootSaga: createRootSaga(sagas)
};

export {
  makeRoutes,
  storeOptions
};
